module.exports = __webpack_public_path__ + "static/media/note1.5c479535.png";